<script setup lang="ts">
import BootstrapButtonDropdown from '../bootstrap-button-dropdown.vue';
</script>
<template>
    <BootstrapButtonDropdown button-class="action-panel-button" menu-class="dropdown-menu-right" auto-drop-up>
        <template #dropdown>
            <span class="bi bi-three-dots-vertical" />
        </template>
        <template #caret>
            <div />
        </template>
        <slot />
    </BootstrapButtonDropdown>
</template>
